import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export enum ExternalSystemId {
  Orion = 2,
  Riskalyze = 5,
}

export interface AssetClassDTO {
  color: string;
  color_group: number;
  id: number;
  name: string;
  y: number;
}

export interface ModelDTO {
  assetAllocationInputModel: AssetClassDTO[];
  riskScore: number | null;
  hypotheticalReturn: number | null;
  id: string;
  orionModelId: number | null;
  portfolioDescription: string | null;
  portfolioName: string;
  riskRange: {
    from: number;
    to: number;
  };
}

export interface ModelGroupDTO {
  adviserId: number | null;
  createdBy: {
    name: string;
    email: string;
  } | null;
  externalSystem: ExternalSystemId | null;
  groupId: string;
  groupName: string;
  modelPortfolios: ModelDTO[];
  defaultPortfolioId: string | null;
}

export interface ModelGroupsDTO {
  modelPortfoliosGroups: ModelGroupDTO[];
  options: {
    defaultAssetAllocation: AssetClassDTO[];
    hasOrionModels: boolean;
  };
}

interface FetchModelGroupsParams {
  clientId: number;
}

const fetchModelGroups = async (params?: FetchModelGroupsParams): Promise<ModelGroupsDTO> => {
  const response = await authFetch(urlWithParams('/Adviser/ModelPortfoliosGroups', params));

  return {
    ...response,
    modelPortfoliosGroups: response.modelPortfoliosGroups.map(group => ({
      ...group,
      defaultPortfolioId: group.modelPortfolios[0]?.id ?? null,
    })),
  };
};

type UseModelGroupsQueryParams = FetchModelGroupsParams;

export const useModelGroupsQuery = (params?: UseModelGroupsQueryParams) => {
  return useQuery(
    queryKeys.modelGroups(params?.clientId),

    () => fetchModelGroups(params),
  );
};
